import { render } from "./LbrxKioskFirstTheme.vue?vue&type=template&id=784d4717&scoped=true"
import script from "./LbrxKioskFirstTheme.vue?vue&type=script&lang=js"
export * from "./LbrxKioskFirstTheme.vue?vue&type=script&lang=js"

import "./LbrxKioskFirstTheme.vue?vue&type=style&index=0&id=784d4717&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784d4717"]])

export default __exports__